import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import { emailMasking, regPhone, findJson, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from './Image';
import Input from './Input';
import Button from './Button';
import ContainerLoader from './ContainerLoader';
import SignUp from './SignUp';
import SnsLogin from './SnsLogin';

import images from '../libs/images';
import consts from '../libs/consts';

export default function SignFindId({ setPage }) {

    const hpref = useRef(null);
    const ref = useRef(null);

    const { signPop, closeSignPop } = usePopup();
    const { user, token, login } = useUser();
    const { country, getLang } = useLang();
    
    const [ hp, sethp ] = useState('');
    const [ num, setnum ] = useState('');
    const [ timer, setTimer ] = useState(false);
    const [ timerView, setTimerView ] = useState(false);
    const [ row, setrow ] = useState("");

    const [ error, setError ] = useState({});

    const [ step, setstep ] = useState(1);

    const [ load, setLoad ] = useState(false);
    
    useEffect(() => {

        hpref?.current?.focus();

    }, [])
    
    useEffect(() => {

        if(step === 2) {
            setnum('');
        }

    }, [step])

    const timeOut = () => {

        console.log("타임 아웃입니다");
        setError({...error, findNum: <LangText id={'error_invalid_auth_time'}/>})
        setTimer(false);
        setstep(1);
    }

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {
            if(step === 1) submitFunc()
            else if(step === 2) checkFunc()
        }
    };

    const submitFunc = () => {

        if(!regPhone.test(hp)) {
            setError({...error, findHp: <LangText id={'error_reg_hp'}/>})
            return;
        }

        if(error?.findHp) return;
       
        let sender = {
            type: 2,
            hp: hp
        }

        APIS.post('/login/auth', sender).then(( { data } ) => {
            console.log('data', data);

            /** 가입되어있고, 인증번호 발송 했으면 */
            setTimer(true);
            setTimerView(true);
            setstep(2);

            setTimeout(() => {
                ref?.current?.focus();
            }, 100)
            /******************************/
        }).catch((e) => {
            console.log(e?.response);
            setError({...error, findHp: <LangText id={e?.response?.data?.msgkey}/> })
            return;
        });
      
    }

    const checkFunc = () => {

        if(num?.length < 6) {
            setError({...error, findNum: <LangText id={'error_invalid_null_auth'}/>})
            return;
        }

        let sender = {
            type: 2,
            hp: hp,
            authNumber: num
        }
        APIS.post('/login/authCheck', sender).then(( { data } ) => {
            console.log('data', data);

            setrow({
                ...data, 
                msg: 
                    data?.type === 'email' ? 
                        getLang({key: 'info_user_id'})
                    : 
                        getLang({key: 'info_user_id_text', replace: { key: '{0}', val: `<span>${getLang({key: data?.type === 'kakao' ? 'text_kakao_easysign' : 'text_naver_easysign'})}</span>` } })
            });

            // 인증번호 일치시
            setstep(3);
            setTimer(false);

        }).catch(({ response }) => {
            // errorMessage(response?.data);
            setError({...error, findNum: <LangText id={response?.data?.msgkey}/>})
            return;
        });
    }

    return (
        
        
        <div
            className={`login_root`}
        >
            <ContainerLoader load={load}/>

            <div className='img' />

            <p className='title'>
                <LangText id={'text_find_id'}/>
            </p>

            <div className='find_form'>
                <Input 
                    refs={hpref}
                    type="tel" 
                    name="findHp" 
                    value={hp} 
                    setValue={sethp} 
                    onKeyDown={handleKeyDown} 
                    label={<LangText id={step === 1 ? 'info_input_hp' : 'info_send_auth'}/>} 
                    error={error} 
                    setError={setError}
                    disabled={timer || step === 3}
                />
                {(step < 3 && timerView) && (
                    <Input 
                        refs={ref}
                        type="tel" 
                        name="findNum" 
                        value={num} 
                        setValue={setnum} 
                        onKeyDown={handleKeyDown} 
                        label={<LangText id={'text_authnum'}/>} 
                        error={error} 
                        setError={setError} 
                        maxlength={6}
                        timer={timer}
                        timerState={timeOut}
                        readOnly={!timer}
                    />
                )}

                {step === 3 && (
                    <div className='find_result_box'>
                        <p className="title" dangerouslySetInnerHTML={{__html: row?.msg}}></p>
                        {row?.type !== 'email' && <p className="title"><LangText id={'info_social_login'}/></p>}
                        <p className='email'>{row?.email}</p>
                    </div>
                )}
                
                
            </div>

            <div className='find_btns'>
                {step === 1 ? (
                    <Button title={<LangText id={'btn_search_go'}/>} onClick={submitFunc}/>
                ) : step === 2 ? (
                    <Button title={<LangText id={'btn_check_auth'}/>} onClick={checkFunc}/>
                ) : step === 3 ? (
                    row?.type === 'email' ? 
                        <Button title={<LangText id={'btn_login'}/>} onClick={() => setPage('')}/>
                    : 
                        <SnsLogin type={row?.type} />
                ) : (
                    <></>
                )}
                
            </div>

        </div>

    )    
}